<template>
  <div>
    <LlEditableQuestionList
      v-for="(chapter, chapterIndex) in chapterListEdit"
      :key="chapterIndex"
      text-label="查核提示"
      :question-list="chapter.sectionList"
      :title="chapter.title"
      :select-template-list="chapter.selectTemplate"
      :chapter-num="chapterIndex"
      :upload-image-url="`/audit_question_version/image/`"
      :upload-attach-url="`/audit_question_version/attach/`"
      :factory-id="1"
      :radio-name="$_getRadioNameByQuestionList(chapterIndex)"
      :law-content="lawContent"
      @law-click="$emit('createSubmit', $event)"
      @question-select="$_questionSelect($event, chapter)"
      @add-click="$_addQuestionClick($event, chapter.sectionList)"
      @delete-click="$_deleteChecklistQues($event, chapterIndex)"
      @question-edit="$_questionEdit($event, chapterIndex)"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      chapterListEdit: [
        {
          title: "chpater1",
          selectTemplate: [2],
          sectionList: [
            {
              title: "section1",
              value: "1",
              questionList: [
                {
                  id: 1,
                  title:
                    "對於具有危害性之化學品，予以標示、製備清單及揭示安全資料表，並採取必要之通識措施。",
                  type: "template",
                  subtitle: "建議題目",
                  focus: 0,
                  level: 10,
                  images: [],
                  attaches: ["attache", "eeewref.pdf"],
                  articles: [
                    {
                      last_version: {
                        no_text: "no2",
                      },
                      act_version: {
                        id: 100,
                        name: "ddd",
                      },
                    },
                  ],
                  remark:
                    "標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準",
                  riskSignal: [
                    { name: "罰鍰", icon: "" },
                    { name: "罰鍰", icon: "" },
                  ],
                },
                {
                  title: "樓板、防火牆和豎井孔洞等重點防火分隔部位的封堵情況",
                  type: "custom",
                  subtitle: "自訂題目",
                  focus: 1,
                  level: 10,
                  images: [],
                  files: [],
                  remark: "",
                },
              ],
            },
            {
              title: "section2",
              value: "2",
              questionList: [
                {
                  id: 2,
                  title: "樓板、防火牆和豎井孔洞等重點防火分隔部位的封堵情況",
                  type: "template",
                  subtitle: "建議題目",
                  focus: 1,
                  level: 10,
                  images: [],
                  attaches: [],
                  articles: [],
                  remark: "eeeee",
                },
                {
                  title: "樓板、防火牆和豎井孔洞等重點防火分隔部位的封堵情況",
                  type: "custom",
                  subtitle: "自訂題目",
                  focus: 1,
                  level: 10,
                  images: [],
                  files: [],
                  remark: "",
                },
              ],
            },
          ],
        },
        {
          title: "chpater2",
          selectTemplate: [2],
          sectionList: [
            {
              title: "標示及通識危害資訊",
              value: "1",
              questionList: [
                {
                  id: 1,
                  title: "樓板、防火牆和豎井孔洞等重點防火分隔部位的封堵情況",
                  type: "template",
                  subtitle: "建議題目",
                  focus: 1,
                  level: 10,
                  images: [],
                  attaches: [],
                  articles: [],
                  remark: "eeeee",
                },
                {
                  title: "樓板、防火牆和豎井孔洞等重點防火分隔部位的封堵情況",
                  type: "custom",
                  subtitle: "自訂題目",
                  focus: 0,
                  level: 10,
                  images: [],
                  files: [],
                  remark: "",
                },
              ],
            },
            {
              title: "危害性化學品之教育訓練",
              value: "2",
              questionList: [
                {
                  id: 2,
                  title: "樓板、防火牆和豎井孔洞等重點防火分隔部位的封堵情況",
                  type: "template",
                  subtitle: "建議題目",
                  focus: 0,
                  level: 10,
                  images: [],
                  attaches: [],
                  articles: [],
                  remark: "eeeee",
                },
                {
                  title: "樓板、防火牆和豎井孔洞等重點防火分隔部位的封堵情況",
                  type: "custom",
                  subtitle: "自訂題目",
                  focus: 1,
                  level: 10,
                  images: [],
                  files: [],
                  remark: "",
                },
              ],
            },
          ],
        },
      ],
      lawContent: {
        title: "水污法水污法水污法水污法 第21條",
        content:
          "本辦法用詞，定義如下：一、環境保護專責及技術人員：指前條法律規定之專責人員、專業技術人員，其類別與級別如下：（一）空氣污染防制專責人員，其級別分為甲級及乙級。（二）廢（污）水處理專責人員，其級別分為甲級及乙級。（三）毒性化學物質專業技術管理人員，其級別分為甲級、乙級及丙級。（四）廢棄物清理專業技術人員：    1.廢棄物清除專業技術人員，其級別分為甲級、乙級及丙級。    2.廢棄物處理專業技術人員，其級別分為甲級及乙級。（五）環境用藥專業技術人員：    1.環境用藥製造業專業技術人員。    2.環境用藥販賣業專業技術人員。    3.病媒防治業專業技術人員。（六）室內空氣品質維護管理專責人員。（七）土壤污染評估調查人員。（八）健康風險評估專責人員。二、訓練：指環境保護專責及技術人員之證照訓練、到職訓練及在職訓。",
        commentTitle: "理律評析",
        riskSignal: [
          { icon: "icon-water", text: "停廠停業" },
          { icon: "icon-water", text: "停廠停業" },
        ],
        commentContent:
          "請確認是否指定為內文內文內文內文內文內文，內文內文內文內文內文內文，內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文，內文內文內文內文內文內文內文內文內文內文、內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內內文內文內文內文內文內。",
      },
    }
  },
  methods: {
    $_getRadioNameByQuestionList(chapterIndex) {
      return `radioName-${chapterIndex}`;
    },
    $_questionSelect($event, chapter) {
      chapter.selectTemplate = $event;
    },
    $_addQuestionClick($event, section) {
      section[$event].questionList.push({
        sequence: 1,
        title: "自訂題目",
        type: "custom",
        subtitle: "自訂題目",
        remark: "",
        images: [],
        files: [],
        focus: 0,
      });
    },
    $_deleteChecklistQues($event, chapterIndex) {
      console.log($event, chapterIndex);
    },
    $_questionEdit($event, index) {
      this.chapterListEdit[index].sectionList = $event;
    },
  }
}
</script>

<style>

</style>